/**
 * Devuelve la clase FbArrayCellEditor, para que el grid la instancie cuando pinta la celda en modo edición.
 *
 * @param {FbCellEditor} FbCellEditor se pasa la clase como injección de dependencia
 * @param {Object} options opciones que se pasan de clase en clase (FbArrayCellEditor -> FbCellEditor -> EcCellEditor)
 * @param {Object} methods metodos que se usan para personalizar la celda.
 * @param {function} [methods.renderChipsFn] debe devolver el contenido html de un chips
 * @returns {FbArrayCellEditor}
 */

// selector para buscar todos los ewc-chips seleccionados
const SELECTOR_CHIPS_SELECTED = 'ewc-chips[aria-selected="true"]';

const defaultOptions = { ecCellName: 'FbArrayCellEditor' };

export default function FbArrayCellEditorClass(FbCellEditor, options, { renderChipsFn } = {}) {
  let indexesChipsSelected = []; // lista de chips seleccionado (en el renderer. Solo puede haber uno ya que entramos directo en modo edición)

  function renderCell({ value: values }) {
    if (!values || !values.length) {
      return '';
    }
    return `&nbsp;
      ${values
        .map((value, index) => {
          return renderChipsFn({ value, index, isSelected: indexesChipsSelected.includes(index), isEditable: true });
        })
        .join('&nbsp;')}`;
  }

  return class FbArrayCellEditor extends FbCellEditor {
    constructor(currentOptions = {}) {
      super(Object.assign({}, defaultOptions, options, currentOptions));

      this.getPartialValuesToReplicate = this.getPartialValuesToReplicate.bind(this);
    }

    /**
     * Devuelve la lista de elementos seleccionados, buscando los ewc-chips[aria-selected="true"].
     * Funciona cuando el valor de la celda es un array, y que se pintan ewc-chips.
     * Sirve para el "Replicar valor" para poder replicar solo ciertos valores de un array
     * @returns {any[]}
     */
    getPartialValuesToReplicate() {
      // recuperamos el valor de la celda
      const value = this.value;

      // buscamos todos los chips seleccionados
      const res = [];
      const eChips = [...this.eCellRendererValue.querySelectorAll(SELECTOR_CHIPS_SELECTED)];

      eChips.forEach(el => {
        // recuperamos los indices de los chips seleccionados
        const index = parseInt(el.getAttribute('index'));
        // recupermos el valor
        res.push(value[index]);
      });
      return res;
    }

    prerender(params) {
      // ejecutamos el hook del FbCellEditor que se encarga de hacer el bind del scope
      super.prerender(params);
      // ejecutamos el hook opcional (solo el list.cell.service lo usa de momento)
      if (this.keyPress === 'click:chips') {
        // aun tenemos el contenido del EcCellRenderer
        // aprovechamos para recuperar el chips seleccionado (el que se ha clicado)
        indexesChipsSelected = [...this.eGridCell.querySelectorAll(SELECTOR_CHIPS_SELECTED)].map(el => parseInt(el.getAttribute('index')));
      } else {
        // sino, no hay ningún chips seleccionado
        indexesChipsSelected = [];
      }
    }

    postrender() {
      this.eCellRendererValue = this.eCellEditor.querySelector('ec-cell-renderer-value');
      // sobreescribimos el contenido de la celda para guardar el chips seleccionado si hay uno
      this.eCellRendererValue.innerHTML = renderCell({ value: this.value, data: this.data });
    }

    onChange({ value, data }) {
      this.eCellRendererValue.innerHTML = renderCell({ value, data });
    }
  };
}
